import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ai-beard-dye"
    exact
    path="/business/products/ai-beard-dye"
    component={AsyncPage}
  />,
];
